function shouldDisableMetaPixel() {
    if (typeof window === "undefined") return true;

    const { hostname, protocol } = window.location;

    return (
        hostname === "localhost" ||
        hostname === "127.0.0.1" ||
        hostname === "::1" ||
        protocol === "file:"
    );
}

export function initMetaPixel({ pixelId, trackPageView = true } = {}) {
    if (typeof window === "undefined") return;
    if (!pixelId) return;
    if (shouldDisableMetaPixel()) return;

    if (window.fbq) {
        if (trackPageView) window.fbq("track", "PageView");
        return;
    }

    !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

    window.fbq("init", pixelId);

    if (trackPageView) {
        window.fbq("track", "PageView");
    }
}

export function trackMeta(eventName, params = {}) {
    try {
        if (typeof window === "undefined") return;
        if (shouldDisableMetaPixel()) return;
        if (!window.fbq) return;

        window.fbq("track", eventName, params, {
            eventID: crypto.randomUUID()
        });
    } catch (_) {
    }
}